import { InspectionCase } from '../../inspection-cases';
import {
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases/inspection-water-supply-data-case.dto';

export class ShutdownPumpDetailsCheckDto extends InspectionCase {
  testData?: InspectionWaterSupplyDataCaseDto[];
}

export class ShutdownPumpDetailsCheck extends ShutdownPumpDetailsCheckDto {
  constructor(
    data: ShutdownPumpDetailsCheckDto = {
      title: 'פרטי משאבת הכיבוי הקיימים באתר'
    }
  ) {
    super(data);
    this.testData = data.testData
      ? data.testData.map((item) => new InspectionWaterSupplyDataCase(item))
      : [new InspectionWaterSupplyDataCase()];
  }

  setInspectionStatus(): void {
    this.isPassed = !this.isApplicable || this._isPassed();
  }

  private _isPassed(): boolean {
    return !this.testData.some((item) => item.isApplicable && !item.isPassed);
  }
}
